// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__XBXab","head":"Table_head__1xKjh","col":"Table_col__2xXSg"};